import { z } from 'zod';
import { usernameSchema } from './enums.js';
// §1.6 Could-tier: per-item agreement votes + comment threads.
export const voteSchema = z.object({ value: z.boolean() });
export const commentCreateSchema = z.object({
    body: z.string().trim().min(1, 'Say something').max(2000),
});
export const commentSchema = z.object({
    id: z.string(),
    listItemId: z.string(),
    authorId: z.string(),
    authorUsername: usernameSchema,
    body: z.string(),
    createdAt: z.string(),
});
//# sourceMappingURL=comments.js.map